import { LOCAL_STORAGE_REFERRER_SITE } from 'shared/constants/localStorageVariables'

export const setReferrer = () => {
  /** Ignore set referrer when coming back from bblid */
  const urlSearchParams = new URLSearchParams(window.location.search)
  if (
    window.location.pathname.indexOf('/signin-oidc') !== -1 &&
    urlSearchParams.has('logoff') &&
    urlSearchParams.get('logoff') === 'true'
  ) {
    return
  }

  const referrer = document.referrer
  if (referrer) localStorage.setItem(LOCAL_STORAGE_REFERRER_SITE, referrer)
}

export const getReferrer = () => {
  return localStorage.getItem(LOCAL_STORAGE_REFERRER_SITE)
}
